<template>
    <div>
        <v-data-table
            :items="desserts"
            :headers="header"
            hide-default-footer
            class="golfGroupTbody"
        >
            <template v-slot:[`item.type`]="{ item }">
                {{ item.point_use_type }}
            </template>
            <template v-slot:[`item.Btn`]="{ item }">
                <a
                    @click="editModal"
                    class="editBtn"
                    :class="{ 'disabled-btn': btn[3].isActive }"
                    :name="item">変更</a>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-4"
                text
                @click="addModal"
                v-if="recordNotExists"
                :disabled="btn[2].isActive">追加する</v-btn>
        </v-card-actions>
        <GolfGroupModal
            ref="Modal"
            :editInfo="findData"
            :typeSelect="point_use_type"
            :remainderType="point_remainder_type"
            @refresh-event="getGolfGroup"
        />
    </div>
</template>

<script>
import {
    GET_GOLFGROUP,
    GET_FLAG_FROM_CODE_MASTER } from '@/constants/master';
import { MasterPagesMixin } from './mixin/MasterPagesMixin.js';
import GolfGroupModal from './modal/GolfGroupModal';
import { authorityMixin } from '@/views/authorityMixin';

export default {
    components: {
        GolfGroupModal
    },
    // マスタ管理の共通項目をMixinする ./mixin/MasterPagesMixin.js
    mixins: [
        authorityMixin,
        MasterPagesMixin
    ],
    data () {
        return {
            // データテーブルのヘッダー
            header: [
                { text: 'グループコード', value: 'golf_group_code', sortable: false, align: 'center' },
                { text: 'グループ名', value: 'golf_group_name', sortable: false },
                { text: 'ポイントタイプ', value: 'point_type_name', sortable: false },
                { text: '期間限定ポイント利用区分', value: 'remainder', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            point_use_type: [],
            point_remainder_type: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            vue_id: 'SCR0010'
        };
    },
    created () {
        this.initialize();
    },
    computed: {
        recordNotExists () {
            return this.desserts.length === 0;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            this.getGolfGroup();
            this.getPointUseTypeList();
            this.getPointRemainderList();
        },
        /** ----------------------------------------------
        * ゴルフグループを取得
        * ---------------------------------------------- */
        getGolfGroup () {
            this.$apollo.mutate({
                mutation: GET_GOLFGROUP
            }).then(res => {
                this.desserts = res.data.getGolfGroupByMaster;
            }).catch(error => {
                this.error = error;
            });
        },
        getPointUseTypeList () {
            this.$apollo.query({
                query: GET_FLAG_FROM_CODE_MASTER,
                variables: {
                    code_key: 'point_use_type',
                    default_display: 0
                }
            }).then(res => {
                this.point_use_type = res.data.GetCodeList.CodeList;
            });
        },
        getPointRemainderList () {
            this.$apollo.query({
                query: GET_FLAG_FROM_CODE_MASTER,
                variables: {
                    code_key: 'point_remainder_type',
                    default_display: 0
                }
            }).then(res => {
                this.point_remainder_type = res.data.GetCodeList.CodeList;
            });
        },
        addModal () {
            this.$refs.Modal.addModal();
        },
        editModal (item) {
            this.findData = this.desserts.find(ele => ele.id === item.id);
            this.$refs.Modal.changeModal();
        }
    }
};
</script>

<style scoped>
    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .v-data-table ::v-deep td{
        max-width: 400px;
    }
</style>
